'use client';

import { useEffect } from 'react';
import { useTranslations } from '../hooks/use-translations';

export function LanguageSelector() {
  const { language, setLanguage, availableLanguages } = useTranslations();

  useEffect(() => {
    // Get language from query parameters
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get('language');

    if (langParam && availableLanguages.some((lang) => lang.code === langParam)) {
      setLanguage(langParam as any);
    }
  }, [setLanguage, availableLanguages]);

  return (
    <div
      style={{
        position: 'fixed' as const,
        bottom: '20px',
        right: '20px',
        zIndex: 1000,
        backgroundColor: 'rgb(255, 255, 255)',
        borderRadius: '16px',
        padding: '5px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
      }}
    >
      <select
        value={language}
        onChange={(e) => setLanguage(e.target.value as any)}
        style={{
          border: 'transparent',
          borderRadius: '4px',
          padding: '4px 8px',
          fontSize: '12px',
          backgroundColor: 'transparent',
          cursor: 'pointer',
          outline: 'none',
          boxShadow: 'none',
        }}
      >
        {availableLanguages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.flag} {lang.name}
          </option>
        ))}
      </select>
    </div>
  );
}
